/** Valid roster grade for dashboard tutor/vocabulary queries (1–12). */
export function resolveDashboardStudentGrade(
  grade: number | null | undefined,
): number | undefined {
  return Number.isFinite(Number(grade)) && (grade as number) >= 1 && (grade as number) <= 12
    ? Number(grade)
    : undefined;
}

/** Avoid queries under unresolved tenant/student identity. */
export function isDashboardIdentityReady(
  membershipKey: string,
  studentKey: string,
): boolean {
  return membershipKey !== 'no-tenant' && studentKey !== 'anonymous';
}
